// src/components/FtuQuestionCard.tsx
import React, { ReactNode } from "react";

interface FtuQuestionCardProps {
  category?: string;
  question: string;
  helpText?: string;
  children: ReactNode;
  isInfoScreen?: boolean;
}

const FtuQuestionCard: React.FC<FtuQuestionCardProps> = ({
  category,
  question,
  helpText,
  children,
  isInfoScreen = false,
}) => {
  return (
    <div className="flex flex-col gap-6 w-full py-6">
      {!isInfoScreen && (
        <header className="flex flex-col">
          <p
            className="font-medium text-[16px] text-[#0c2624] tracking-[0.4px]"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            {category}
          </p>

          <h1
            className="m-0 font-semibold text-[32px] leading-normal text-[#1e1e1e]"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            {question}
          </h1>

          {helpText && (
            <p
              className="m-0 font-medium text-xl text-[#757575]"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              {helpText}
            </p>
          )}
        </header>
      )}

      <div className="w-full">{children}</div>
    </div>
  );
};

export default FtuQuestionCard;
